enum CodeType {
  'PHONE' = 'PHONE',
  'EMAIL' = 'EMAIL',
}

export { CodeType };
